const PRODUCT_CATEGORY_BASE_URL = '/product-preferences';

export const routeCreator = {
  list: () => PRODUCT_CATEGORY_BASE_URL,
  update: (id: string) => `${PRODUCT_CATEGORY_BASE_URL}/${id}/update`,
  create: () => `${PRODUCT_CATEGORY_BASE_URL}/create`,
  details: (id: string) => `${PRODUCT_CATEGORY_BASE_URL}/${id}`,
};
